import { IconButton, Spinner, Tooltip, Typography, Chip, Input, Button } from '@material-tailwind/react'
import { FiRefreshCw } from 'react-icons/fi'

export function HeaderDesktop({
  loading, rowsCount, query, setQuery,
  masterRef, allSelected, someSelected, onMasterToggle,
  onRefresh, onApproveSelected, onRejectSelected
}) {
  return (
    <div className="hidden sm:flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
      <div className="flex items-center gap-2">
        <Tooltip content="Actualizar">
          <IconButton variant="text" onClick={onRefresh} title="Actualizar">
            {loading ? <Spinner className="h-4 w-4" /> : <FiRefreshCw />}
          </IconButton>
        </Tooltip>

        <Tooltip content={allSelected || someSelected ? 'Limpiar selección' : 'Seleccionar todo'}>
          <input
            ref={masterRef}
            type="checkbox"
            checked={allSelected}
            onChange={onMasterToggle}
            className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-0 cursor-pointer"
            aria-label="Seleccionar todo"
          />
        </Tooltip>

        <Typography variant="small" className="text-gray-600">Pendientes por aprobar (no expiradas)</Typography>
        <Chip value={`${rowsCount} invitación(es)`} color="blue-gray" size="sm" className="rounded-full ml-2" />
      </div>

      <div className="flex items-center gap-2">
        <Input label="Buscar" value={query} onChange={(e) => setQuery(e.target.value)} crossOrigin="" className="min-w-[220px]" />
        <Button onClick={onApproveSelected} disabled={!allSelected && !someSelected}>Aprobar seleccionados</Button>
        <Button variant="outlined" color="red" onClick={onRejectSelected} disabled={!allSelected && !someSelected}>Rechazar seleccionados</Button>
      </div>
    </div>
  )
}